<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0" style="height: 410px">
      <!-- Global info-->
      <v-container class="chart-header d-flex flex-column pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-1">
          {{ $t("customerCountGrowth") }}
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2 gray--text">
          {{ $t("newAndTotalCustomersLastSixMonths") }}
        </v-card-text>
      </v-container>

      <!-- area chart-->
      <apexchart
        v-if="hasData"
        type="line"
        height="337"
        width="100%"
        :options="chartOptions"
        :series="chartSeries"
      />
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      chartApiResponse: {},
    };
  },
  computed: {
    hasData() {
      return this.chartSeries[0].data.some((val) => val > 0);
    },
    chartCategories() {
      const values = Object.values(this.chartApiResponse || {});
      let lastSixMonths = values.slice(-6);
      return lastSixMonths.map((item) => item.label);
    },
    chartSeries() {
      const values = Object.values(this.chartApiResponse || {});
      let lastSixMonths = values.slice(-6);
      const totalCustomer = lastSixMonths.map(
        (item) => item.monthlyInvoices.customers.total_customers
      );
      const newCustomer = lastSixMonths.map(
        (item) => item.monthlyInvoices.customers.new_customers
      );
      return [
        {
          name: this.$t("totalCustomer"),
          data: totalCustomer,
        },
        {
          name: this.$t("newCustomer"),
          data: newCustomer,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "line",
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        colors: ["#3B82F6", "#10B981"],

        stroke: {
          curve: "smooth",
          width: [2, 2],
        },

        markers: {
          size: 5,
          colors: ["#3B82F6", "#10B981"],
          strokeColors: "#ffffff",
          strokeWidth: [2, 2],
          hover: {
            size: 6,
          },
        },

        xaxis: {
          categories: this.chartCategories,
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          min: 0,
          labels: {
            style: {
              fontSize: "10px",
            },
            offsetX: this.$vuetify.rtl ? -40 : 0,
            formatter: (value) =>
              `${this.$numberFormat(value)} ${this.$store.state.currency.name}`,
          },
        },

        grid: {
          strokeDashArray: 4,
        },

        tooltip: {
          y: {
            formatter(val) {
              return val.toLocaleString("fa-IR") + this.$store.state.currency.name;
            },
          },
        },

        dataLabels: {
          enabled: false,
        },
      };
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.getProgressData(newVal);
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getProgressData(newVal);
      },
    },
  },
  mounted() {
    this.getProgressData();
  },
  methods: {
    getProgressData(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/invoice-by-month", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          let res = response.data.data;
          app.chartApiResponse = res;
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .apexcharts-legend.position-bottom .apexcharts-legend-series,
::v-deep .apexcharts-legend.position-top .apexcharts-legend-series {
  gap: 0.5rem;
  padding-top: 10px;
}
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
